import { Injectable } from '@angular/core';
import { RegionClient } from '../client/region.client';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RegionStore {
    readonly regions$ = this._regionClient.list().pipe(shareReplay(1));

    constructor(private readonly _regionClient: RegionClient) {}
}
